<header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom rounded-top-1">
  <i class="me-2 fa-solid fa-user" aria-hidden="true"></i>
  <h6 class="m-0">Настройки на профила</h6>
</header>
<ul class="m-0 list-unstyled">
  <li class="p-3 d-flex justify-content-between align-items-center border-bottom">
    <span class="fw-medium">
      <i class="text-muted fa-solid fa-lock" aria-hidden="true"></i>
      <span class="ms-2">Промяна на парола</span>
      <p class="small text-muted m-0">Актуализирайте паролата, която използвате за вход.</p>
    </span>
    <button class="btn btn-sm btn-nz-primary flex-shrink-0"
            (click)="onOpenPasswordModal()">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      <span class="ms-2">Промени</span>
    </button>
  </li>
  <li class="p-3 d-flex justify-content-between align-items-center border-bottom">
    <span class="fw-medium">
      <i class="text-muted fa-solid fa-at" aria-hidden="true"></i>
      <span class="ms-2">Промяна на електронна поща</span>
      <p class="small text-muted m-0">{{ profile.userEmail }}</p>
    </span>
    <button class="btn btn-sm btn-nz-primary flex-shrink-0"
            (click)="onOpenEmailModal()">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      <span class="ms-2">Промени</span>
    </button>
  </li>
  <li class="p-3 d-flex justify-content-between align-items-center border-bottom">
    <span class="fw-medium">
      <i class="text-muted fa-solid fa-key" aria-hidden="true"></i>
      <span class="ms-2">Промяна на метода на потвърждение</span>
      <p class="small text-muted m-0">
        {{ currentUser?.userData?.confirmationMethodName }}
      </p>
    </span>
    <button class="btn btn-sm btn-nz-primary flex-shrink-0"
            (click)="onOpenUserConfirmationMethodModal()">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      <span class="ms-2">Промени</span>
    </button>
  </li>
  <li class="p-3 d-flex justify-content-between align-items-center border-bottom">
    <span class="fw-medium">
      <i class="text-muted fa-solid fa-map-location-dot" aria-hidden="true"></i>
      <span class="ms-2">Промяна на адрес по подразбиране</span>
      <p class="small text-muted m-0">
        {{ !!profile.populatedPlaceName ? profile.populatedPlaceName : 'Актуализирайте адрес по подразбиране.' }}
      </p>
    </span>
    <button class="btn btn-sm btn-nz-primary flex-shrink-0"
            (click)="onOpenUserDefaultAddressModal()">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      <span class="ms-2">Промени</span>
    </button>
  </li>
</ul>
